/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Section_ChargesInputs */



/**
* | output |
* | --- |
* | "Charges this period" |
*
* @param {Partner_Dashboard_Detail_Section_ChargesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_section_charges = /** @type {((inputs?: Partner_Dashboard_Detail_Section_ChargesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Section_ChargesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten in diesem Zeitraum")
	return /** @type {LocalizedString} */ ("Charges this period")
});